import * as types from './mutations-type';
import DashboardService from "@dashboard/services/DashboardService";
import i18n from "@/plugins/i18n"

export default {
    toggleEditMode({ commit }, value) {
        commit(types.SET_EDITING_MODE, value);
        commit(types.SET_WIDGET_DRAWER, value);
    },

    async saveDashboard({ commit }, payload) {
        const response = await DashboardService.saveDashboard(payload);
        return response.data;
    },

    async deleteDashboard({ commit }, layoutId) {
        const response = await DashboardService.deleteLayout(layoutId);

        if (response.status === 200) {
            this._vm.$toast.success(i18n.t('dashboard.notifications.deleteLayoutSuccess'), {
                color: '#03AC8C',
                queueable: true
            });
        } else {
            this._vm.$toast.error(i18n.t('dashboard.notifications.deleteLayoutError'), {
                queueable: true
            });
        }

        return response.status === 200;
    },

    async fetchLayoutConfig({ commit }, layoutId) {
        const response = await DashboardService.getLayoutConfig(layoutId);
        commit(types.SET_LAYOUT, {
            ...response.data,
            widgets: DashboardService.transformData(response.data.widgets)
        });
    },

    async fetchWidgetConfig({ getters, dispatch }, [widgetId, filters]) {
        return new Promise((resolve, reject) => {
            DashboardService.getWidgetValues(widgetId, filters).then(res => {
                resolve(res.data)
            }).catch(async err => {
                console.log(err)
                if (err.response.status === 404) {
                    resolve({ reload: true, origin: 'fetchWidgetConfig' })
                }
                reject(err)
            });
        })
    },

    async shareLayout({ commit }, payload) {
        const response = await DashboardService.shareLayout(payload);

        if (response.status === 200) {
            this._vm.$toast.success(i18n.t('dashboard.notifications.sharedLayoutSuccess'), {
                color: '#03AC8C',
                queueable: true
            });
        } else {
            this._vm.$toast.error(i18n.t('dashboard.notifications.sharedLayoutError'), {
                queueable: true
            });
        }
    },

    async fetchUserLayouts({ commit }) {
        const response = await DashboardService.listUserLayouts();
        let layouts = response.data;

        if (layouts && layouts.length > 0) {
            layouts = _.map(layouts, (layout) => ({
                ...layout,
                widgets: DashboardService.transformData(layout.widgets)
            }))
        }
       commit(types.SET_LAYOUTS, layouts);
    },

    updateFilters({ commit }, payload) {
        commit('SET_FILTERS', payload);
    },

    loadFilters({ commit }, layoutId) {
        const filters = JSON.parse(localStorage.getItem(`filters-${layoutId}`)) || JSON.parse(localStorage.getItem('filters-global'));
        if (filters) {
            commit('SET_FILTERS', filters);
        }
    },

    clearSpecificConfiguration({ commit }, layoutId) {
        if (localStorage.getItem(`filters-${layoutId}`))
            localStorage.removeItem(`filters-${layoutId}`);
    },

    saveFilters({ state }, { layoutId, isGlobal }) {
        const filtersToSave = { ...state.filters, isGlobal };
        if (isGlobal) {
            localStorage.setItem('filters-global', JSON.stringify(filtersToSave));

            for (let i = 0; i < localStorage.length; i++) {
                const key = localStorage.key(i);
                if (key.startsWith('filters-') && key !== 'filters-global') {
                    localStorage.removeItem(key);
                }
            }
        } else {
            localStorage.setItem(`filters-${layoutId}`, JSON.stringify(filtersToSave));

            if (localStorage.getItem('filters-global')) {
                localStorage.removeItem('filters-global');
            }
        }
    }
};
